// core
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class TpaHandoverService extends ApiService {

  tpaHandover(payload: any): Promise<any> {
    return firstValueFrom(this.post('/v2/tpa/handover', payload));
  }
}
